<template>
    <div class="index-two">
        <p>
            组件2：接收<el-button>{{msg}}</el-button>
        </p>
    </div>
</template>
<script>
    import indexTransfer from '../../../assets/index-transfer.js'
    export default {
        data(){
            return {
                msg:0,
            }
        },
        methods:{},
        mounted(){
            indexTransfer.$on("receiveComponemt", msg => {
                this.msg = msg
            })
        }
    }
</script>
<style scoped>
    .index-two{
        width: 200px;
        height: 200px;
        line-height: 200px;
        float: left;
        border: 1px solid #f1f1f1;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/transfer-value/index-two.vue